/** @param {Node} node */
export default function* getParentElements(node) {
  while ((node = node.parentElement)) {
    yield node;
  }
}
